import { NgModule } from "@angular/core";
import { AudioWaveformVisualizerSvg } from "./audio-waveform-visualizer/audio-waveform-visualizer.component";

@NgModule({
  declarations: [AudioWaveformVisualizerSvg],
  exports: [AudioWaveformVisualizerSvg],
})
export class SvgModule {}



// WEBPACK FOOTER //
// ./src/assets/svg/svg.module.ts